import { CALL_API } from './api'
import moment from 'moment-timezone'
import {
    getAccessToken,
    getBSRSToken,
    getAllToken,
    getServiceToken,
    setServiceToken,
    setToken,
    timeFormat,
    CORE_API_ENDPOINT
} from 'Lib'

export default store => next => action => {
    const entry = action[CALL_API]
    const currentTime = moment().format(timeFormat)

    if (typeof entry !== 'object') return next(action)

    if (typeof (entry) !== "undefined") {
        if (typeof (entry.tokentype) !== "undefined" && entry.tokentype) {
            const { service_token, service_expires_on } = getServiceToken()
            if (!service_token) return next(action)

            const serviceDuration = moment.duration(moment.unix(service_expires_on).diff(currentTime))
            const serviceMinutes = serviceDuration.asMinutes()

            const bsrs_token = getBSRSToken()
            if (serviceMinutes < 10) {
                fetch(`${CORE_API_ENDPOINT}/o365/service_token`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${bsrs_token}`
                    }
                })
                    .then(res => {
                        return res.json()
                    })
                    .then(json => setServiceToken(json))
                    .then(() => next(action))
            } else {
                next(action)
            }
        }
    }

    const isO365 = entry.types[0].startsWith("O365")

    if (isO365) {
        const token = getAccessToken()

        if (!token) return next(action)

        const { expires_on, refresh_token } = getAllToken()
        const currentTime = moment().format(timeFormat)
        const duration = moment.duration(moment.unix(expires_on).diff(currentTime))
        const minutes = duration.asMinutes()
        // console.log("Token", expires_on, refresh_token, minutes)
        if (minutes < 10) {
            fetch(`${CORE_API_ENDPOINT}/o365/refresh_token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ refresh_token })
            })
                .then(res => res.json())
                .then(json => setToken(json))
                .then(() => next(action))
        } else {
            next(action)
        }

    } else {
        next(action)
    }
}


// WEBPACK FOOTER //
// ./src/middlewares/checkToken.js